import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

import { PathNames } from "application/routes";
import { useAppSelector } from "application/store";
import {
  Description,
  SharePopUp,
  ShareSmartBanner,
  InviteFriendsBanner,
  ShareDealBanner,
  ReferralBonusBanner,
} from "application/components";
import { AmplitudeEvent, useAmplitude } from "application/hooks/useAmplitude";

import {
  AdditionalMaterials,
  PitchDeck,
  ShortOverview,
  Team,
  VideosSlider,
  InvestmentInfo,
} from "./components";

import { Wrapper, Container } from "./styles";

const DealOverview: FC = () => {
  const navigate = useNavigate();
  const { trackEvent } = useAmplitude();
  const { deal } = useAppSelector((state) => state.deal);
  const { user } = useAppSelector((state) => state.auth);

  const [showShareModal, setShowShareModal] = useState(false);

  const isInvestorReferral = !!user?.investorReferral;
  const overview = deal?.overview;

  const goToInvest = () => {
    navigate(PathNames.invest);
    trackEvent(AmplitudeEvent.Deals_Invest_button, { deal_title: deal?.title });
  };

  return (
    <Wrapper>
      <Container>
        <InvestmentInfo />
      </Container>
      <ShortOverview />
      {isInvestorReferral ? (
        <Container>
          <ReferralBonusBanner onClick={goToInvest} />
        </Container>
      ) : (
        <Container>
          <ShareDealBanner onClick={() => setShowShareModal(true)} />
        </Container>
      )}
      {!!overview?.videos.length && <VideosSlider />}
      {!!overview?.problem && (
        <Container>
          <Description title="Problem" text={overview?.problem || ""} />
        </Container>
      )}
      {!!overview?.solution && (
        <Container>
          <Description title="Solution" text={overview?.solution || ""} />
        </Container>
      )}
      <Container>
        <InviteFriendsBanner onClick={() => setShowShareModal(true)} />
      </Container>
      {!!overview?.market && (
        <Container>
          <Description title="Market" text={overview?.market || ""} />
        </Container>
      )}
      {!!overview?.team.length && <Team />}
      {!!overview?.pitchDecks.length && <PitchDeck />}
      {!!overview?.additionalMaterials.length && <AdditionalMaterials />}
      <Container>
        <ShareSmartBanner onClick={() => setShowShareModal(true)} />
      </Container>
      {showShareModal && (
        <SharePopUp
          open={showShareModal}
          onClose={() => setShowShareModal(false)}
        />
      )}
    </Wrapper>
  );
};

export default DealOverview;
